import { PageContainer } from '../../../shared/PageContainer';
import { ListAndDetail, useFeedback } from "@sis/react-library"
import ListIcon from '@mui/icons-material/List';
import { listAndDetailSamplesRoutes } from "../../ListAndDetailSamplesNavigation";
import { useState } from "react";
import { callMimicApi } from "../../../../utils/commonUtils";
import { CityTownDto } from "../../../sampleData/sampleDataReducer";
import { useSampleData } from "../../../sampleData/useSampleData";
import { ListAndDetailSamplesBasicPageInfo } from './ListAndDetailSamplesBasicPageInfo';

export const ListAndDetailSamplesBasicPage = () => {

  const { cityTowns, deleteCityTowns } = useSampleData();
  const [deleting, setDeleting] = useState(false);

  const { showSuccess, showError } = useFeedback();

  const handleDelete = async (cityTownsToDelete: CityTownDto[]) => {
    try {
      // In the api call, uncomment the exception in there to test errors coming from the api
      setDeleting(true);

      await callMimicApi();
      await deleteCityTowns(cityTownsToDelete);

      setDeleting(false);
      showSuccess('The countries were deleted');
    } catch (ex) {
      showError(`An error occured: ${ex}`);
    }
  }

  const listItemRender = (item: CityTownDto) => <>{item.description}</>;

  return (
    <PageContainer
      heading='List Samples - Basic'
      icon={<ListIcon />}
      pageInfo={<ListAndDetailSamplesBasicPageInfo />}
      wrapRightElementForMobile={false}
    >
      <ListAndDetail
        items={cityTowns}
        keyValue={(item) => item.code}
        // You might get a sonarqube warning here saying React components should not be nested.
        // You can mark this as a false warning because Sonarqube doesn't know how the itemRender is used
        // and if it's a function that can be raised at any time then the state will be lost and everything will rerender.
        // However itemRender is only called in the initial render of the ListAndDetail component, and never rerendered
        // so it's fine to mark it as a false warning.
        itemRender={listItemRender}

        // Below we are sayig you can search by code or description, typing in MK will bring up Milton keynes for example
        searchFields={['code', 'description']}
        listUrl={listAndDetailSamplesRoutes.basic}
        newUrl={listAndDetailSamplesRoutes.new}
        editUrl={listAndDetailSamplesRoutes.edit}
        //additionalUrlsToCheckForSelecting={[otherUrls]} // If you list has multiple details pages, you can add the urls here to set the selected items
        deleteOptions={{
          onDelete: handleDelete,
          busyDeleting: deleting,
          // You can add additional delete functionality, uncomment below to try out
          // onDeleteConfirmCustomText: (items) => <>Delete these items? <br />{items.map(i => <Fragment key={i.code}><br />{i.description}</Fragment>)}</>,
          // deleteButtonDisabled: (items) => items.some((i) => i.countryCode === 'UK'),  // Disable if any UK city selected
          // deleteButtonHidden: (items) => items.some((i) => i.countryCode === 'UK'),  // Hide button if any UK city selected
          // deleteButtonTooltip: (items) => `Delete ${items.length} item${items.length === 1 ? '' : 's'}`
        }}
        // uncomment below to auto collapse list (for more retails space) when selecting an item
        // collapseOnItemSelect={{ forInitialState: true, forURLSelected: true }}
        // uncomment to auto collapse list (for more retails space) when clicking on new item
        // collapseOnNew={{ forInitialState: true, forURLSelected: true }}

        // You can customize the colours, uncomment below to see example
        // colours={{
        //   background: 'linear-gradient(to right, rgb(120, 120, 120), rgb(20, 20, 20))',
        //   colour: 'white',
        //   headerDividerColour: 'white',
        //   itemBackground: (item, checked) => checked ? 'linear-gradient(to bottom right, green, rgb(10, 10, 10))' : undefined,  // You can set the item background colour as well
        //   itemHoverColour: (item, checked) => item.countryCode === "UK" ? 'blue' : undefined,
        //   itemHoverBackground: (item, checked) => item.countryCode === "UK" ? 'orange' : 'rgb(200, 200, 200)',
        //   itemSelectedColour: (item, checked) => 'green',
        //   itemSelectedBackground: (item, checked) => 'linear-gradient(to bottom right, rgb(230, 230, 230), rgb(190, 190, 190))',
        //   iconColour: 'white',
        //   iconDisabledColour: 'rgb(160, 160, 160)',
        //   desktopExpandIconColour: 'black',
        //   noItemsColour: 'rgb(150, 150, 150)'
        // }}
        // colours={{
        //   headerBackground: 'linear-gradient(to bottom right, rgb(120, 120, 120), rgb(20, 20, 20))',
        //   headerColour: 'white',
        //   borderColour: 'rgb(100, 100, 100)',
        //   iconColour: 'white'
        // }}      

        //positionPersistLeft  // You can force the position to stay on the left
        //onExpandedCollapsed={(expanded) => { console.log(expanded ? 'expanded' : 'collapsed') }}

        // You can add customizations on the checkboxes as well, uncomment below to try out
        // checkOptions={{
        //   checkDisabled: (item) => item.countryCode === 'UK', // disable for UK
        //   checkTooltip: (item) => item.countryCode === 'UK' ? "Disabled for UK" : undefined,
        //   checkHidden: (item) => item.countryCode === 'UK', // disable for UK
        //   onCheckChange: (item, checked, allCheckedItems) => {
        //     console.log('item: ', item);
        //     console.log('checked: ', checked);
        //     console.log('allCheckedItems: ', allCheckedItems);
        //   }
        // }}
        // Comment out below if you don't want to show the select all checkbox
        //showSelectAll={false}
        reduceHeight={174} // Makes the height of the list 100vh minus this height. Defaults to 170 for PageLayoutDefault area.
      />
    </PageContainer>
  )
}
